<div style="display:show" id="divdata">
    <div class="modal-header">
        <h6 class="modal-title medium" *ngIf="type == 'ADD'">{{'addOrgUnit' | translate}}</h6>
        <h6 class="modal-title medium" *ngIf="type == 'EDIT'">{{'editOrgUnit' | translate}}</h6>
        <button type="button" class="close" aria-label="Close" (click)="activeModal.dismiss('Cross click')">
            <span aria-hidden="true">&times;</span>
        </button>
    </div>
    <div class=" col-lg-6 col-md-1 float-left">
        <div class="form-group">
            <label> {{'code' | translate}}
                <span class="text-danger medium">*</span>
            </label>
            <input type="text" class="form-control" placeholder="{{'orgCode' | translate}}"
                   [(ngModel)]="orgData.orgUnitCode"
                   maxlength="250">
        </div>
    </div>
    <div class=" col-lg-6 col-md-1 float-left">
        <div class="form-group">
            <label> {{'orgUnitType' | translate}}
                <span class="text-danger medium">*</span>
            </label>
            <input ng2-auto-complete autocomplete="off" [(ngModel)]="orgTypeModel" name="orgTypeModel"
                   [source]="orgTypeObservableSource.bind(this)" [value-formatter]="orgTypeFormatter"
                   [list-formatter]="autoCompleteListOrgTypeFormatter" value-property-name="id"
                   display-property-name="orgUnitTypeName" placeholder="{{'typeChooseOrgUnitType' | translate}}"
                   class="form-control" (valueChanged)="gotNewValue($event,'orgType')" [accept-user-input]=false
                   blank-option-text="Select" [no-match-found-text]="warning" required>
        </div>
    </div>
    <div class=" col-lg-6 col-md-1 float-left ">
        <div class="form-group">
            <label>{{'name'| translate}}
                <span class="text-danger medium">*</span>
            </label>
            <input type="text" class="form-control" placeholder="{{'name' | translate}}" [(ngModel)]="orgData.orgName"
                   maxlength="250">
        </div>
    </div>

    <div class=" col-lg-6 col-md-1 float-left">
        <div class="form-group">
            <label>{{'nameLocale'| translate}}
            </label>
            <input type="text" class="form-control" placeholder="{{'nameLocale' | translate}}"
                   [(ngModel)]="orgData.orgNameLocale" maxlength="250">
        </div>
    </div>
    <div class=" col-lg-6 col-md-1 float-left">
        <div class="form-group">
            <label>{{'description'| translate}}
            </label>
            <input type="text" class="form-control" placeholder="{{'description' | translate}}"
                   [(ngModel)]="orgData.description" maxlength="250">
        </div>
    </div>
    <div class=" col-lg-6 col-md-1 float-left">
        <div class="form-group">
            <label>{{'descriptionLocale'| translate}}
            </label>
            <input type="text" class="form-control" placeholder="{{'descriptionLocale' | translate}}"
                   [(ngModel)]="orgData.descriptionLocale" maxlength="250">
        </div>
    </div>

    <div class=" col-lg-6 col-md-1 float-left">
        <div class="form-group">
            <label for="sup">{{'headOfUnit' | translate}}</label>
            <input ng2-auto-complete autocomplete="off" [(ngModel)]="primarySupervisorModel"
                   name="primarySupervisorModel"
                   [source]="employeeObservableSource.bind(this)" [list-formatter]="autoCompleteListFormatter"
                   value-property-name="id" display-property-name="displayName"
                   placeholder="{{'typeChooseHOU' | translate}}"
                   class="form-control" (valueChanged)="gotNewValue($event,'primary')" [accept-user-input]=false
                   blank-option-text="Select" [no-match-found-text]="warning" id="sup" max-num-list=5>
            <span class="info-text"> {{'headOfUnit' | translate}} </span>
        </div>
    </div>
    <div class=" col-lg-6 col-md-1 float-left">
        <div class="form-group">
            <label for="spoc">{{'hrSpoc' | translate}}</label>
            <input ng2-auto-complete autocomplete="off" [(ngModel)]="hrSpocModel" name="hrSpocModel"
                   [source]="hrrObservableSource.bind(this)" [list-formatter]="autoCompleteListFormatter"
                   value-property-name="id"
                   display-property-name="displayName" placeholder="{{'typeChooseCcAdmin' | translate}}"
                   class="form-control"
                   (valueChanged)="gotNewValue($event,'hrSpoc')" [accept-user-input]=false blank-option-text="Select"
                   [no-match-found-text]="warning" id="spoc" max-num-list=5>
            <span class="info-text">{{'hrSinglePointOfCont' | translate}} </span>
        </div>
    </div>
    <div class=" col-lg-6 col-md-1 float-left">
        <div class="form-group">
            <label for="spoc">{{'ccAdmin' | translate}}</label>
            <input ng2-auto-complete autocomplete="off" [(ngModel)]="ccAdmin" name="ccAdmin"
                   [source]="hrrObservableSource.bind(this)" [list-formatter]="autoCompleteListFormatter"
                   value-property-name="id"
                   display-property-name="displayName" placeholder="{{'typeChooseCcAdmin' | translate}}"
                   class="form-control"
                   (valueChanged)="gotNewValue($event,'ccAdmin')" [accept-user-input]=false blank-option-text="Select"
                   [no-match-found-text]="warning" id="spoc" max-num-list=5>
            <span class="info-text"> {{'ccAdmin' | translate}} </span>
        </div>
    </div>
    <div class=" col-lg-6 col-md-1 float-left">
        <div class="form-group">
            <label for="spoc">{{'ccManager' | translate}}</label>
            <input ng2-auto-complete autocomplete="off" [(ngModel)]="ccManager" name="ccManager"
                   [source]="hrrObservableSource.bind(this)" [list-formatter]="autoCompleteListFormatter"
                   value-property-name="id"
                   display-property-name="displayName" placeholder="{{'typeChooseCcManager' | translate}}"
                   class="form-control"
                   (valueChanged)="gotNewValue($event,'ccManager')" [accept-user-input]=false blank-option-text="Select"
                   [no-match-found-text]="warning" id="spoc" max-num-list=5>
            <span class="info-text"> {{'ccManager' | translate}} </span>
        </div>
    </div>
    <div class=" col-lg-6 col-md-1 float-left">
        <div class="form-group">
            <label for="spoc">{{'leaveAdministrator' | translate}}</label>
            <input ng2-auto-complete autocomplete="off" [(ngModel)]="leaveAdministrator" name="leaveAdministrator"
                   [source]="hrrObservableSource.bind(this)" [list-formatter]="autoCompleteListFormatter"
                   value-property-name="id"
                   display-property-name="displayName" placeholder="{{'typeChooseLeaveAdministrator' | translate}}"
                   class="form-control" (valueChanged)="gotNewValue($event,'leaveAdministrator')"
                   [accept-user-input]=false
                   blank-option-text="Select" [no-match-found-text]="warning" id="spoc" max-num-list=5>
            <span class="info-text"> {{'leaveAdministrator' | translate}} </span>
        </div>
    </div>
    <div class=" col-lg-6 col-md-1 float-left">
        <div class="form-group">
            <label for="spoc">{{'orgCat' | translate}}</label>
            <input ng2-auto-complete autocomplete="off" [(ngModel)]="orgCat" name="orgCat"
                   [source]="orgCatObservableSource.bind(this)" [list-formatter]="autoCompleteOrgCat"
                   value-property-name="id"
                   display-property-name="code" placeholder="{{'typeChooseOrgCat' | translate}}" class="form-control"
                   (valueChanged)="gotNewValue($event,'orgCat')" [accept-user-input]=false blank-option-text="Select"
                   [no-match-found-text]="warning" id="spoc" max-num-list=5>
            <span class="info-text"> {{'orgCat' | translate}} </span>
        </div>
    </div>
    <div class="col-lg-6 col-md-6 float-left">
        <div class="form-group">
            <label> {{'selectParent' | translate}}
            </label>
            <input ng2-auto-complete autocomplete="off" [(ngModel)]="parent" name="parent"
                   [source]="organisationUnitObservable.bind(this)" [list-formatter]="autoCompleteOrgName"
                   value-property-name="id" display-property-name="orgName" placeholder="Select Parent"
                   class="form-control"
                   (valueChanged)="gotNewValue($event,'parent')" [accept-user-input]=false blank-option-text="Select"
                   [no-match-found-text]="warning" id="spoc" max-num-list=5>
        </div>
    </div>
    <div class="col-lg-12 col-md-12 float-right">
        <div class="modal-footer">
            <div style="flex-grow: 1;"></div>
            <button class="btn btn-secondary float-right" (click)="activeModal.dismiss('Cross click')"> {{'close' |
                translate}}
            </button>
            <button class="btn btn-primary float-right" (click)="saveOrgData()" *ngIf="type == 'ADD'"
                    [disabled]=disableButton>
                {{'add' | translate}}
            </button>
            <button class="btn btn-primary float-right" (click)="saveOrgData()" *ngIf="type == 'EDIT'"
                    [disabled]=disableButton>
                {{'updateChanges' |
                translate}}
            </button>
        </div>
    </div>

</div>


// WEBPACK FOOTER //
// ./src/app/tools/org/addParentOrganization.html